import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  data: any;
  status: ReduxStateType;
}

const initialState: InitialState = {
  data: null,
  status: ReduxStateType.ERROR,
};

const deleteRequestSlice = createSlice({
  name: "deleteRequest",
  initialState,
  reducers: {
    setDeleteRequestData: (state, action) => {
      state.data = action.payload;
    },
    deleteRequestStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    deleteRequestSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    deleteRequestFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  setDeleteRequestData,
  deleteRequestStart,
  deleteRequestSuccess,
  deleteRequestFailed,
} = deleteRequestSlice.actions;

export default deleteRequestSlice.reducer;
